<script>
  import { Component } from 'vue-property-decorator'
  import { VCard } from 'vuetify/lib'

  @Component({
    components: {
      VCard,
    },
  })
  export default class Card extends VCard {}
</script>
